import React, { useContext } from "react";
import { jsonFromDocument } from "cerulean";

const UserFeaturesContext = React.createContext<API.UserFeatures>({});
export const UserFeaturesContextProvider = ({ children }: { children: React.ReactNode }) => {
  const userFeatures = jsonFromDocument("features") as API.UserFeatures;
  return (
    <UserFeaturesContext.Provider value={userFeatures}>
      {children}
    </UserFeaturesContext.Provider>
  );
};

export const useUserFeatures = () => useContext(UserFeaturesContext);

export default UserFeaturesContext;
